<template>
  <transition name="fade" mode="out-in">
    <div :class="[getDefinitionClass(), reqDef.type, 'definitionObj', {'w3-hide':!validateQuestFlow(reqDef.id) || reqDef.type === 'header'}, {'pulse': languageChanged}, {'labelHide': isLabelHide()}, {'w3-hide': isRepeatableGroup() && !isEditable && (!reqObj.children || reqObj.children.length === 0)}]" :id="reqDef.id">

      <!-- show label -->
      <label v-if="reqDef.type !== 'group' && reqDef.type !== 'header' && reqDef.type !== 'conditional'"
        :class="['label', reqDef.id, {'hide': (reqDef.label === null || reqDef.label === ''), 'bigLabel': isBigLabel(), 'pointer': isGallery()}]"
        :for="reqDef.id"
        v-on:click="toggleMonochoiceCarousel()"
      >
        <i v-if="labelIcon" :class="[labelIcon]"></i>
        <span class="label">{{ reqDef.label }} <span v-if="isRequired && isEditable" class="required">*</span></span>

        <i v-if="isGallery()" :class="['fa', 'fa-angle-down', {'open': carouselMonochoiceShow}]"></i>
      </label>

      <!-- show field from definition object -->
      <definition-text
        v-if="reqDef.type === 'text' || reqDef.type === 'longText' || reqDef.type === 'id' || reqDef.type === 'code'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="true"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :apiparams="apiparams" :placeholder="getPlaceholder()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @textFormatError="textFormatError" @newLanguageSelected="newLanguageSelected"
      />
      <definition-number
        v-if="reqDef.type === 'number'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="true"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :apiparams="apiparams" :placeholder="getPlaceholder()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @numberFormatError="numberFormatError" @newLanguageSelected="newLanguageSelected"
      />
      <definition-date
        v-else-if="reqDef.type === 'date' || reqDef.type === 'datetime'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :placeholder="getPlaceholder()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @dateFormatError="dateFormatError"
      />
      <definition-date-interval
        v-else-if="reqDef.type === 'dateInterval'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :placeholder="getPlaceholder()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @dateIntervalFormatError="dateIntervalFormatError"
      />
      <definition-num-interval
        v-else-if="reqDef.type === 'numInterval'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :placeholder="getPlaceholder()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @numIntervalFormatError="numIntervalFormatError"
      />
      <definition-mono-choice
        v-else-if="reqDef.type === 'mono-choice'"
        :class="{'w3-show': isGallery() && carouselMonochoiceShow, 'w3-hide': isGallery() && !carouselMonochoiceShow}"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :gallery="isGallery()" :radio="isRadio()" :parentRepeatableGroupOpen="parentRepeatableGroupOpen"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :placeholder="getPlaceholder()" :showCarousel="isGallery() && carouselMonochoiceShow"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory"
        @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
      />
      <definition-multi-choice
        v-else-if="reqDef.type === 'multi-choice'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :gallery="isGallery()" :checkbox="isCheckbox()" :doublelist="isDoublelist()" :showMultilanguage="true"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :placeholder="getPlaceholder()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @newLanguageSelected="newLanguageSelected"
        @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
      />
      <definition-html
        v-else-if="(reqDef.type === 'html')"
        :content="content"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :tinyId="getTinyId()" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="true"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @htmlFormatError="htmlFormatError" @newLanguageSelected="newLanguageSelected"
        @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
      />
      <definition-image
        v-else-if="(reqDef.type === 'image')"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :tinyId="getTinyId()" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="true"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :signature="isSignature()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @imageFormatError="imageFormatError" @newLanguageSelected="newLanguageSelected" @refreshRepeatableGroupCode="refreshRepeatableGroupCode"
        @refreshDefinitionContent="refreshDefinitionContent"
      />
      <definition-file
        v-else-if="(reqDef.type === 'file')"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :tinyId="getTinyId()" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="true"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @imageFormatError="imageFormatError" @newLanguageSelected="newLanguageSelected" @refreshRepeatableGroupCode="refreshRepeatableGroupCode"
        @refreshDefinitionContent="refreshDefinitionContent"
      />

      <!-- Chart fields -->
      <definition-geo-chart
        v-else-if="reqDef.type === 'geo-chart' && apiparams.mapsKey"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :apiparams="apiparams" :language="language"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory"
      />
      <definition-table-chart
        v-else-if="reqDef.type === 'table-chart'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory"
      />
      <definition-combo-chart
        v-else-if="reqDef.type === 'combo-chart'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :visualDefinition="visualDefinition" :language="language"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory"
      />
      <definition-pie-chart
        v-else-if="reqDef.type === 'pie-chart'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :visualDefinition="visualDefinition" :language="language"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory"
      />

      <!-- Conditional fields -->
      <definition-conditional
        v-if="reqDef.type === 'conditional'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :showMultilanguage="true" :content="content"
        :parentObj="getRequestObjectById(reqDef.validation.condParentId)" :parentDef="getRequestDefinitionById(reqDef.validation.condParentId, content.requestDefinition)" :reqObjForAdd="requestObjectForAdd" :modeView="modeView" :validateForm="validateForm" :validateAddForm="validateAddForm" :repeatableGroupId="getRepeatableGroupId()"
        :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory" @textFormatError="textFormatError" @numberFormatError="numberFormatError" @newLanguageSelected="newLanguageSelected"
        @conditionalDefinitionChange="conditionalDefinitionChange" @refreshRepeatableGroupCode="refreshRepeatableGroupCode" @refreshConditionalFieldId="refreshConditionalFieldId"
      />

      <!-- Cron fields -->
      <definition-cron
        v-if="reqDef.type === 'cron'"
        :definition="reqDef" :object="reqObj" :editable="isEditable" :mandatoryValidation="mandatoryValidation" :languageSelected="languageSelected" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode"
        :requestObjectForAdd="requestObjectForAdd" :requestObjectForAddModified="requestObjectForAddModified" :language="language" :visualDefinition="visualDefinition" :apiparams="apiparams" :placeholder="getPlaceholder()"
        @refreshDefinition="refreshDefinition" @validateMandatory="validateMandatory"
      />

      <!-- Recursivity of 'DefinitionObj' for type 'group' -->
      <div v-else-if="(reqDef.type === 'group' || reqDef.type === 'header') && validateQuestFlow(reqDef.id)"
        :class="[
          'definition-wrapper',
          'group',
          {'open': repeatableGroupOpen},
          {'w3-hide': isRepeatableGroup() && !isEditable && (!reqObj.children || reqObj.children.length === 0)},
          {'error_group_validate': isRepeatableGroup() && mandatoryValidation && mandatoryValidation.validateKey && mandatoryValidation.validateKey !== ''}
        ]"
      >
        <div :class="['group-header', reqDef.id, {'w3-hide': reqDef.label === ''}]">
          <div v-if="!isRepeatableGroup() || (isRepeatableGroup() && isEditable && !isDefinitionBuilder() && !modifyingAddForm)" class="title">
            <div :class="[{'toggle_accordion': isRepeatableGroup() || isToggle() }]" v-on:click="repeatableGroupOpen = !repeatableGroupOpen">
              <span v-if="reqDef.label !== ''" class="labelText">
                <i v-if="labelIcon" :class="[labelIcon]"></i>
                <span class="add" v-if="isRepeatableGroup()">{{ getLang('add') }}</span>
                <span> {{ reqDef.label }} <span v-if="isRequired" class="required">*</span></span>
              </span>
              <i v-if="isRepeatableGroup()" :class="['sherpa-icon ', 'icon-anadir-generico', {'open': repeatableGroupOpen}]"></i>
              <i v-else-if="isToggle()" :class="['icon_toggle', 'fa', 'fa-angle-down', {'rotate180': repeatableGroupOpen}]"></i>
            </div>
            <transition name="fade" mode="out-in">
              <span v-if="isRepeatableGroup() && mandatoryValidation && mandatoryValidation.validateKey && mandatoryValidation.validateKey !== ''" class="error_validate label mandatory repeatableGroup" v-text="messageErrorMandatory"></span>
            </transition>
          </div>
          <div v-else-if="isRepeatableGroup() && !isEditable && !isDefinitionBuilder() && !modifyingAddForm" class="title">
            <div class="toggle_accordion">
              <span v-if="reqDef.label !== ''" class="labelText">
                <span> {{ reqDef.label }}</span>
              </span>
            </div>
          </div>
        </div>

        <div :class="['group-elements', {'show': !isRepeatableGroup() || isEditable}, {'add-repeatable-group-item': isRepeatableGroup()}]">
          <!-- Definition Children -->
          <div v-if="reqDef.children && reqDef.children.length > 0" v-bind:class="{'w3-dropdown-content': !repeatableGroupOpen && (isRepeatableGroup() || isToggle()), 'w3-animate-opacity': !repeatableGroupOpen && (isRepeatableGroup() || isToggle()), 'w3-hide': (isRepeatableGroup() && !isEditable)}">

            <!-- Normal presentation -->
            <definition-obj v-for="child in reqDef.children"
              :key="child.id"
              :id="child.id"
              :definitionId="definitionId"
              :reqDef="child"
              :reqObj="getRequestObjectById(child.id)"
              :reqObjForAdd="requestObjectForAdd"
              :content="content"
              :modeView="modeView"
              :index="index"
              :moment="moment"
              :validateForm="validateForm"
              :validateAddForm="validateAddForm"
              :repeatableGroupId="getRepeatableGroupId()"
              :languageSelected="languageSelected"
              :definitionContentId="definitionContentId"
              :parentRepeatableGroupCode="repeatableGroupCode"
              :parentRepeatableGroupOpen="repeatableGroupOpen"
              :requestObjectForAddModified="requestObjectForAddModified"
              :language="language"
              :visualDefinition="visualDefinition"
              :authorization="authorization"
              :type="type"
              :visuals="visuals"
              :apiparams="apiparams"
              :formAddErrors="formAddErrors"
              :formAddSaved="formAddSaved"
              :formAddRemoved="formAddRemoved"
              @refreshDefinition="refreshDefinition"
              @refreshDefinitionContent="refreshDefinitionContent"
              @repeatableGroupModified="repeatableGroupModified"
              @activateValidatingAddForm="activateValidatingAddForm"
              @deactivateValidatingAddForm="deactivateValidatingAddForm"
              @errorAddForm="errorAddForm"
              @formAddSaved="formAddSavedEvent"
              @newLanguageSelected="newLanguageSelected"
              @conditionalDefinitionChange="conditionalDefinitionChange"
              @refreshRepeatableGroupCode="refreshRepeatableGroupCode"
              @removingAddForm="callRemovingAddForm"
              @waitingProcessInit="waitingProcessInit"
              @modifyingAddForm="callModifyingAddForm"
              @taskLink="taskLink"
              @refreshConditionalFieldId="refreshConditionalFieldId"
            />
          </div>

          <!-- Definition Group Task / BUTTONS -->
          <div v-if="reqDef.task && reqDef.task.length > 0 && (!isRepeatableGroup() || (isRepeatableGroup() && repeatableGroupOpen && isEditable))"
            :class="[getDefinitionFieldClassTaskClass(), 'groupTasks', {'w3-hide': isRepeatableGroup() && !isEditable}]"
          >
            <definition-task
              :definition="reqDef" :object="reqObj" :definitionObject="content.requestObject" :taskRefresh="taskRefresh" :definitionId="definitionId" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :repeatableGroupPresentation="repeatableGroupPresentation" :istoggle="isToggleTask()"
              @refreshDefinition="refreshDefinition" @refreshDefinitionContent="refreshDefinitionContent"
            />
          </div>

          <!-- Definition Repeatable Group / ADD BUTTON -->
          <transition name="fade" mode="out-in">
            <definition-repeatable-group-add-button
              v-if="isRepeatableGroup() && !maxRepeatableGroupElements() && isEditable && !isDefinitionBuilder() && repeatableGroupOpen"
              :repeatableGroupOpen="repeatableGroupOpen"
              :validateAddForm="validateAddForm"
              :validateForm="validateForm"
              :language="language"
              :formAddErrors="formAddErrors"
              :formAddSaved="formAddSaved"
              :label="reqDef.label"
              @callAdd="callAdd"
            />
          </transition>
        </div>

        <!-- Definition Repeatable Group / DRAGGABLE -->
        <definition-repeatable-group v-if="isRepeatableGroup()"
          class="repeatable"
          :definition="reqDef"
          :object="reqObj"
          :modeView="modeView"
          :definitionId="definitionId"
          :definitionContent="content"
          :repeatableGroupId="getRepeatableGroupId()"
          :validateForm="validateForm"
          :languageSelected="languageSelected"
          :definitionContentId="definitionContentId"
          :repeatableGroupCode="repeatableGroupCode"
          :editable="isEditable"
          :timeline="isTimeline()"
          :definitionBuilder="isDefinitionBuilder()"
          :language="language"
          :visualDefinition="visualDefinition"
          :authorization="authorization"
          :type="type"
          :visuals="visuals"
          :apiparams="apiparams"
          :formAddRemoved="formAddRemoved"
          @modifyingAddForm="callModifyingAddForm"
          @removingAddForm="callRemovingAddForm"
          @repeatableGroupModified="repeatableGroupModified"
          @errorModifyForm="errorModifyForm"
          @newLanguageSelected="newLanguageSelected"
          @refreshDefinitionContent="refreshDefinitionContent"
          @refreshRepeatableGroupCode="refreshRepeatableGroupCode"
          @waitingProcessInit="waitingProcessInit"
          @taskLink="taskLink"
        />
      </div>

      <!-- show field error -->
      <transition name="fade" mode="out-in">
        <span v-if="!isRepeatableGroup() && isEditable && mandatoryValidation && mandatoryValidation.validateKey && mandatoryValidation.validateKey !== ''" class="error_validate label mandatory" v-text="messageErrorMandatory"></span>

        <span v-else-if="isEditable && (reqDef.type === 'text' || reqDef.type === 'longText') && textFormatValidation && textFormatValidation.validateKey && textFormatValidation.validateKey !== ''" class="error_validate label textFormat" v-text="messageErrorTextFormat"></span>
        <span v-else-if="isEditable && reqDef.type === 'number' && numberFormatValidation && numberFormatValidation.validateKey && numberFormatValidation.validateKey !== ''" class="error_validate label numberFormat" v-text="messageErrorNumberFormat"></span>
        <span v-else-if="isEditable && (reqDef.type === 'date' || reqDef.type === 'datetime') && dateFormatValidation && dateFormatValidation.validateKey && dateFormatValidation.validateKey !== ''" class="error_validate label dateFormat" v-text="messageErrorDateFormat"></span>
        <span v-else-if="isEditable && reqDef.type === 'dateInterval' && dateIntervalFormatValidation && dateIntervalFormatValidation.validateKey && dateIntervalFormatValidation.validateKey !== ''" class="error_validate label dateIntervalFormat" v-text="messageErrorDateIntervalFormat"></span>
        <span v-else-if="isEditable && reqDef.type === 'numInterval' && numIntervalFormatValidation && numIntervalFormatValidation.validateKey && numIntervalFormatValidation.validateKey !== ''" class="error_validate label numIntervalFormat" v-text="messageErrorNumIntervalFormat"></span>
        <span v-else-if="isEditable && reqDef.type === 'html' && htmlFormatValidation && htmlFormatValidation.validateKey && htmlFormatValidation.validateKey !== ''" class="error_validate label htmlFormat" v-text="messageErrorHtmlFormat"></span>
      </transition>

    </div>
  </transition>
</template>

<script>
import DefinitionHtml from './html' // comment for 'definition.js' low size
import DefinitionImage from './image' // comment for 'definition.js' low size
import DefinitionFile from './file' // comment for 'definition.js' low size
import DefinitionRepeatableGroup from './repeatableGroup' // comment for 'definition.js' low size
import DefinitionRepeatableGroupAddButton from '../action/addButton' // comment for 'definition.js' low size
import DefinitionTask from './task' // comment for 'definition.js' low size
import DefinitionConditional from './conditional' // comment for 'definition.js' low size
import DefinitionGeoChart from './chart/geoChart' // comment for 'definition.js' low size
import DefinitionTableChart from './chart/tableChart' // comment for 'definition.js' low size
import DefinitionComboChart from './chart/comboChart' // comment for 'definition.js' low size
import DefinitionPieChart from './chart/pieChart' // comment for 'definition.js' low size
import DefinitionCron from './cron' // comment for 'definition.js' low size
import DefinitionDateInterval from './dateInterval' // comment for 'definition.js' low size
import DefinitionNumInterval from './numInterval' // comment for 'definition.js' low size
import DefinitionNumber from './number' // comment for 'definition.js' low size
import DefinitionText from './text'
import DefinitionDate from './date'
import DefinitionMonoChoice from './monoChoice'
import DefinitionMultiChoice from './multiChoice'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
import language from '../language'

export default {
  name: 'definition-obj',
  props: [
    'content',
    'reqDef',
    'reqObj',
    'reqObjForAdd',
    'definitionId',
    'modeView',
    'validateForm',
    'validateAddForm',
    'repeatableGroupId',
    'languageSelected',
    'definitionContentId',
    'definitionContentCode',
    'index',
    'moment',
    'parentRepeatableGroupCode',
    'parentRepeatableGroupOpen',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'formAddSaved',
    'formAddRemoved'
  ],
  data () {
    return {
      isEditable: false,
      isRequired: false,
      mandatoryValidation: null,
      textFormatValidation: null,
      numberFormatValidation: null,
      htmlFormatValidation: null,
      imageFormatValidation: null,
      dateFormatValidation: null,
      dateIntervalFormatValidation: null,
      numIntervalFormatValidation: null,
      requestObjectForAdd: null,
      requestObjectForAddCopy: null,
      repeatableGroupOpen: false,
      languageChanged: false,
      repeatableGroupCode: null,
      labelIcon: null,
      carouselMonochoiceShow: !(this.parentRepeatableGroupCode !== undefined && this.parentRepeatableGroupCode !== null),
      taskRefresh: null,
      modifyingAddForm: false,
      formAddErrors: 0,
      repeatableGroupPresentation: null
    }
  },
  components: {
    DefinitionGeoChart, // comment for 'definition.js' low size
    DefinitionTableChart, // comment for 'definition.js' low size
    DefinitionComboChart, // comment for 'definition.js' low size
    DefinitionPieChart, // comment for 'definition.js' low size
    DefinitionCron, // comment for 'definition.js' low size
    DefinitionHtml, // comment for 'definition.js' low size
    DefinitionImage, // comment for 'definition.js' low size
    DefinitionFile, // comment for 'definition.js' low size
    DefinitionRepeatableGroup, // comment for 'definition.js' low size
    DefinitionRepeatableGroupAddButton, // comment for 'definition.js' low size
    DefinitionTask, // comment for 'definition.js' low size
    DefinitionConditional, // comment for 'definition.js' low size
    DefinitionDateInterval, // comment for 'definition.js' low size
    DefinitionNumInterval, // comment for 'definition.js' low size
    DefinitionNumber, // comment for 'definition.js' low size
    DefinitionText,
    DefinitionDate,
    DefinitionMonoChoice,
    DefinitionMultiChoice
  },
  beforeMount () {
    this.initDefinitionObj()
  },
  methods: {
    initDefinitionObj () {
      this.isEditable = transport.methods.isEditable(this.modeView, this.reqDef)
      this.isRequired = transport.methods.isRequired(this.reqDef)
      this.repeatableGroupPresentation = this.visualDefinition.getRepeatableGroupPresentation(this.reqDef.id)

      if (this.isRepeatableGroup()) {
        this.setRepeatableObjectForAdd()
      } else if (this.reqObjForAdd) {
        this.requestObjectForAdd = this.reqObjForAdd
      }

      if (this.requestObjectForAdd) {
        this.requestObjectForAddCopy = JSON.parse(JSON.stringify(this.requestObjectForAdd))
      }

      // Get Repeatable Group Code
      if (this.parentRepeatableGroupCode) {
        this.repeatableGroupCode = this.parentRepeatableGroupCode
      } else {
        var requestObjectCode = transport.methods.getRequestObjectById(
          transport.methods.getAliasTypeCode([this.reqDef], true),
          this.requestObjectForAdd
        )
        if (requestObjectCode) {
          this.repeatableGroupCode = requestObjectCode.textValue
        } else {
          this.repeatableGroupCode = null
        }
      }
      if (this.repeatableGroupCode === null && !this.isRepeatableGroup() && this.definitionContentCode) {
        this.repeatableGroupCode = this.definitionContentCode
      }

      this.labelIcon = this.getDefinitionFieldIcon()
    },
    setRepeatableObjectForAdd () {
      this.requestObjectForAdd = this.getEmptyRequestObjectForCopy()
      if (this.isDefinitionBuilder() && this.reqObj.children) {
        this.repeatableGroupOpen = false
      } else {
        if ((!this.reqObj.children || this.reqObj.children.length === 0) && !this.isRepeatablePresentationClass('hide-add-form')) {
          this.repeatableGroupOpen = true
        } else {
          this.repeatableGroupOpen = false
        }
      }
    },
    getDefinitionClass () {
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      return definition.class
    },
    isGallery () {
      return this.isClass('gallery')
    },
    isToggle () {
      return this.isClass('toggle')
    },
    isTimeline () {
      return this.isClass('timeline')
    },
    isSignature () {
      return this.visualDefinition.getDefinitionFields(this.reqDef.id).signature
    },
    isPlaceholder () {
      return this.visualDefinition.getDefinitionFields(this.reqDef.id).placeholder
    },
    isRadio () {
      var result = null
      if (this.isClass('radio')) {
        result = this.getDefinitionClass()
      }
      return result
    },
    isCheckbox () {
      var result = null
      if (this.isClass('checkbox')) {
        result = this.getDefinitionClass()
      }
      return result
    },
    isDoublelist () {
      var result = null
      if (this.isClass('doublelist')) {
        result = this.getDefinitionClass()
      }
      return result
    },
    isDefinitionBuilder () {
      return this.isClass('definition-builder')
    },
    isClass (classStr) {
      return this.isInClassString(classStr, this.getDefinitionClass())
    },
    isRepeatablePresentationClass (classStr) {
      if (this.repeatableGroupPresentation) {
        return this.isInClassString(classStr, this.repeatableGroupPresentation.class)
      }
    },
    isInClassString (classStr, allClasses) {
      var result = false
      if (allClasses) {
        var classes = allClasses.split(' ')
        if (classes && classes.length > 0) {
          for (var i = 0; i < classes.length && !result; i++) {
            result = (classes[i] === classStr)
          }
        }
      }
      return result
    },
    isToggleTask () {
      var result = false
      var definitionClass = this.getDefinitionFieldClassTaskClass()
      if (definitionClass) {
        var classes = definitionClass.split(' ')
        if (classes && classes.length > 0) {
          for (var i = 0; i < classes.length && !result; i++) {
            result = (classes[i] === 'toggle')
          }
        }
      }
      return result
    },
    getPlaceholder () {
      var result = null
      if (this.isPlaceholder()) {
        result = this.visualDefinition.getDefinitionFields(this.reqDef.id).placeholderText
        if (!result) {
          result = this.reqDef.label
        }
      }
      return result
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    getDefinitionFieldClassTaskClass () {
      var result = null
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition) {
        result = definition.tasks
      }
      return result
    },
    getDefinitionFieldIcon () {
      var result = null
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition) {
        result = definition.icon
      }
      return result
    },
    isLabelHide () {
      var result = false
      if (this.visualDefinition.definition) {
        var labelHide = this.visualDefinition.definition.labelHide
        if (labelHide) {
          for (var i = 0; i < labelHide.length && !result; i++) {
            if (this.reqDef.id === labelHide[i]) {
              result = true
            }
          }
        }
      }
      return result
    },
    refreshDefinition (object, scope) {
      this.mandatoryValidation = null
      this.textFormatValidation = null
      this.numberFormatValidation = null
      this.dateFormatValidation = null
      this.dateIntervalFormatValidation = null
      this.numIntervalFormatValidation = null
      if (this.isRepeatableGroup()) {
        // -- repeatable group elements addition
        if (object && object.children && object.id === object.children[0].id) {
          this.reqObj.children = this.reqObj.children.concat(object.children)
        } else {
          this.requestObjectForAdd = transport.methods.modifyRequestObject(this.requestObjectForAdd, object)
          this.requestObjectForAddModified.ts = moment().valueOf()
        }
      } else {
        this.$emit('refreshDefinition', object, scope)
      }
    },
    getEmptyRequestObjectForCopy (id) {
      var result = null
      var emptyRequestObject = null
      if (!id) {
        emptyRequestObject = transport.methods.getEmptyRequestObject([this.reqDef], true)
      } else {
        emptyRequestObject = transport.methods.getEmptyRequestObject(
          [this.getRequestDefinitionById(id, [this.reqDef])],
          true
        )
      }
      if (emptyRequestObject) {
        result = emptyRequestObject[0]
      }
      return result
    },
    getRequestObjectById (id) {
      var requestObject = null
      if (this.requestObjectForAdd) {
        requestObject = transport.methods.getRequestObjectById(id, [this.requestObjectForAdd])
        if (!requestObject) {
          requestObject = this.getEmptyRequestObjectForCopy(id)
          this.requestObjectForAdd = transport.methods.modifyRequestObject(this.requestObjectForAdd, requestObject)
        }
      } else if (this.reqObj) {
        requestObject = transport.methods.getRequestObjectById(id, [this.reqObj])
      }

      if (!requestObject) {
        requestObject = transport.methods.getRequestObjectById(id, this.content.requestObject)
      }

      return requestObject
    },
    getValidateMandatoryText (validateKey) {
      if (validateKey) {
        return this.getLang(validateKey, ['min', 'max'], [this.reqDef.validation.mandatory.min, this.reqDef.validation.mandatory.max])
      } else {
        return this.getLang('empty')
      }
    },
    getValidateTextFormatText (validateKey, format) {
      if (validateKey) {
        return this.getLang(validateKey, ['lengthMin', 'lengthMax', 'message'], [format.lengthMin, format.lengthMax, this.getMessage(format.message)])
      } else {
        return this.getLang('empty')
      }
    },
    getValidateNumberFormatText (validateKey, format) {
      if (validateKey) {
        return this.getLang(validateKey, ['lengthMin', 'lengthMax', 'message'], [format.lengthMin, format.lengthMax, this.getMessage(format.message)])
      } else {
        return this.getLang('empty')
      }
    },
    getValidateHtmlFormatText (validateKey, format) {
      if (validateKey) {
        return this.getLang(validateKey, ['lengthMin', 'lengthMax', 'message'], [format.lengthMin, format.lengthMax, this.getMessage(format.message)])
      } else {
        return this.getLang('empty')
      }
    },
    getValidateImageFormatText (validateKey, format) {
      if (validateKey) {
        return this.getLang(validateKey, ['message'], [this.getMessage(format.message)])
      } else {
        return this.getLang('empty')
      }
    },
    getValidateDateFormat (validateKey, format) {
      if (validateKey) {
        return this.getLang(validateKey, ['message'], [this.getMessage(format.message)])
      } else {
        return this.getLang('empty')
      }
    },
    getValidateNumIntervalFormat (validateKey, format) {
      if (validateKey) {
        return this.getLang(validateKey, ['message'], [this.getMessage(format.message)])
      } else {
        return this.getLang('empty')
      }
    },
    getMessage (message) {
      var result = ''
      if (message && message.trim() !== '') {
        result = ': ' + message.toLowerCase()
      }
      return result
    },
    validateMandatory (timeEvent, requestObject) {
      var mandatoryKey = transport.methods.validateMandatory(this.reqDef, requestObject)
      this.mandatoryValidation = this.fieldFormatError(timeEvent, this.getValidateMandatoryText, mandatoryKey)
    },
    textFormatError (timeEvent, validateTextFormatKey, format) {
      this.textFormatValidation = this.fieldFormatError(timeEvent, this.getValidateTextFormatText, validateTextFormatKey, format)
    },
    numberFormatError (timeEvent, validateNumberFormatKey, format) {
      this.numberFormatValidation = this.fieldFormatError(timeEvent, this.getValidateNumberFormatText, validateNumberFormatKey, format)
    },
    htmlFormatError (timeEvent, validateHtmlFormatKey, format) {
      this.htmlFormatValidation = this.fieldFormatError(timeEvent, this.getValidateHtmlFormatText, validateHtmlFormatKey, format)
    },
    imageFormatError (timeEvent, validateImageFormatKey, format) {
      this.imageFormatValidation = this.fieldFormatError(timeEvent, this.getValidateImageFormatText, validateImageFormatKey, format)
    },
    dateFormatError (timeEvent, validateDateFormatKey, format) {
      this.dateFormatValidation = this.fieldFormatError(timeEvent, this.getValidateDateFormat, validateDateFormatKey, format)
    },
    dateIntervalFormatError (timeEvent, validateDateIntervalFormatKey, format) {
      this.dateIntervalFormatValidation = this.fieldFormatError(timeEvent, this.getValidateDateFormat, validateDateIntervalFormatKey, format)
    },
    numIntervalFormatError (timeEvent, validateNumIntervalFormatKey, format) {
      this.numIntervalFormatValidation = this.fieldFormatError(timeEvent, this.getValidateNumIntervalFormat, validateNumIntervalFormatKey, format)
    },
    fieldFormatError (timeEvent, validationFunction, validationKey, format) {
      var fieldValidation = {
        t: timeEvent,
        validateKey: validationKey,
        validateText: validationFunction(validationKey, format)
      }
      return fieldValidation
    },
    validateQuestFlow (reqDefId) {
      var result = false
      if (this.repeatableGroupId === null || this.repeatableGroupId === this.reqDef.id) {
        result = transport.methods.validateQuestFlow(this.content.requestDefinition, this.content.requestObject, reqDefId)
      } else if (this.repeatableGroupId) {
        var definition = this.getRequestDefinitionById(this.repeatableGroupId, this.content.requestDefinition)
        if (!definition) {
          definition = this.getRequestDefinitionById(this.repeatableGroupId, [this.reqDef])
        }
        if (this.requestObjectForAdd) {
          result = transport.methods.validateQuestFlow(
            [definition],
            [this.requestObjectForAdd],
            reqDefId
          )
        } else {
          result = transport.methods.validateQuestFlow(
            [definition],
            [this.reqObj],
            reqDefId
          )
        }
      } else {
        result = true
      }
      return result
    },
    getRequestDefinitionById (id, requestDefinition) {
      return transport.methods.getRequestDefinitionById(id, requestDefinition)
    },
    callAdd () {
      if ((!this.validateForm || !this.validateForm.validating) && (!this.validateAddForm || !this.validateAddForm.validatingAdd)) {
        this.checkAddForm()
      }
    },
    checkAddForm () {
      // change validateAddForm / watcher waiting for fields validation...
      this.activateValidatingAddForm(null)
      var errors = transport.methods.validateForm(this.modeView, this.content.requestDefinition, [this.requestObjectForAdd], true)
      this.formAddErrors = errors.errorsNumber
      if (this.formAddErrors === 0) {
        // No errors on fields. Let's add to repeatable group.
        if (this.reqObj.children === null) {
          this.reqObj.children = []
        }

        // -- put on the final of the array
        if (!this.reqDef.validation.repeatableType || this.reqDef.validation.repeatableType === 'push') {
          this.reqObj.children.push(JSON.parse(JSON.stringify(this.requestObjectForAdd)))
        // -- put on the beginning of the array
        } else {
          this.reqObj.children.unshift(JSON.parse(JSON.stringify(this.requestObjectForAdd)))
        }

        // Reset add form
        this.requestObjectForAdd = JSON.parse(JSON.stringify(this.requestObjectForAddCopy))

        this.deactivateValidatingAddForm()

        this.formAddSavedEvent(this.repeatableGroupCode, this.reqDef.id)

      // Errors on fields.
      } else {
        this.$nextTick(() => {
          this.deactivateValidatingAddForm()
          // this.errorAddForm(this.formAddErrors)
        })
      }
    },
    activateValidatingAddForm (id) {
      var idAux = id
      if (idAux === null) {
        idAux = this.reqDef.id
      }
      this.$emit('activateValidatingAddForm', idAux)
    },
    deactivateValidatingAddForm () {
      this.$emit('deactivateValidatingAddForm')
    },
    isRepeatableGroup () {
      return transport.methods.isRepeatableGroup(this.reqDef)
    },
    maxRepeatableGroupElements () {
      return transport.methods.maxRepeatableGroupElements(this.reqDef, this.reqObj.children)
    },
    getRepeatableGroupId () {
      var repeatableGroupId = this.repeatableGroupId
      if (repeatableGroupId === null && this.isRepeatableGroup()) {
        repeatableGroupId = this.reqDef.id
      }
      return repeatableGroupId
    },
    repeatableGroupModified (repeatableGroupObj, callUpdate, code) {
      if (this.reqDef.task) {
        this.taskRefresh = moment().valueOf()
      }
      this.modifyingAddForm = false
      this.$emit('repeatableGroupModified', repeatableGroupObj, callUpdate, code)
    },
    errorAddForm (formAddErrors) {
      this.$emit('errorAddForm', formAddErrors)
    },
    errorModifyForm (formModifyErrors) {
      this.$emit('errorModifyForm', formModifyErrors)
    },
    formAddSavedEvent (repeatableGroupCode, repeatableId) {
      if (this.reqDef.id === repeatableId) {
        this.$emit('formAddSaved', repeatableGroupCode, repeatableId)
      }
    },
    callModifyingAddForm (code) {
      this.repeatableGroupOpen = false
      this.modifyingAddForm = true
      this.$emit('modifyingAddForm', code)
    },
    callRemovingAddForm (code, id) {
      this.repeatableGroupOpen = false
      this.modifyingAddForm = true
      this.$emit('removingAddForm', code, id)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    getTinyId () {
      var id = this.reqDef.id
      if (this.index && this.moment) {
        id = this.reqDef.id + '_' + this.index + '_' + this.moment + '_edit'
      }
      return id
    },
    conditionalDefinitionChange (conditionalFieldId, newReqObj) {
      if (this.isRepeatableGroup()) {
        transport.methods.changeConditionalObjects(this.requestObjectForAdd.children, conditionalFieldId, newReqObj)
      } else {
        this.$emit('conditionalDefinitionChange', conditionalFieldId, newReqObj)
      }
    },
    refreshConditionalFieldId (newReqObj) {
      this.$emit('refreshConditionalFieldId', newReqObj)
    },
    isBigLabel () {
      return this.reqDef.type.endsWith('-chart')
    },
    toggleMonochoiceCarousel () {
      if (this.isGallery()) {
        this.carouselMonochoiceShow = !this.carouselMonochoiceShow
      }
    },
    getLang (key, params, values) {
      return language(this.language, key, params, values)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    refreshRepeatableGroupCode (code) {
      var aliasCode = transport.methods.getAliasTypeCode([this.reqDef], true)
      if (aliasCode) {
        var codeReqObj = transport.methods.getRequestObjectById(aliasCode, [this.requestObjectForAdd])
        codeReqObj.textValue = code
        this.repeatableGroupCode = code
      } else {
        this.$emit('refreshRepeatableGroupCode', code)
      }
    },
    waitingProcessInit () {
      this.$emit('waitingProcessInit')
    }
  },
  computed: {
    messageErrorMandatory () {
      var result = ''
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition && definition.errorText && definition.errorText.mandatoryText) {
        result = definition.errorText.mandatoryText
      } else {
        result = this.mandatoryValidation.validateText
      }
      return result
    },
    messageErrorTextFormat () {
      var result = ''
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition && definition.errorText && definition.errorText.formatText) {
        result = definition.errorText.formatText
      } else {
        result = this.textFormatValidation.validateText
      }
      return result
    },
    messageErrorNumberFormat () {
      var result = ''
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition && definition.errorText && definition.errorText.formatText) {
        result = definition.errorText.formatText
      } else {
        result = this.numberFormatValidation.validateText
      }
      return result
    },
    messageErrorDateFormat () {
      var result = ''
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition && definition.errorText && definition.errorText.formatText) {
        result = definition.errorText.formatText
      } else {
        result = this.dateFormatValidation.validateText
      }
      return result
    },
    messageErrorDateIntervalFormat () {
      var result = ''
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition && definition.errorText && definition.errorText.formatText) {
        result = definition.errorText.formatText
      } else {
        result = this.dateIntervalFormatValidation.validateText
      }
      return result
    },
    messageErrorNumIntervalFormat () {
      var result = ''
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition && definition.errorText && definition.errorText.formatText) {
        result = definition.errorText.formatText
      } else {
        result = this.numIntervalFormatValidation.validateText
      }
      return result
    },
    messageErrorHtmlFormat () {
      var result = ''
      var definition = this.visualDefinition.getDefinitionFields(this.reqDef.id)
      if (definition && definition.errorText && definition.errorText.formatText) {
        result = definition.errorText.formatText
      } else {
        result = this.htmlFormatValidation.validateText
      }
      return result
    }
  },
  watch: {
    validateForm (validateForm) {
      if (validateForm && validateForm.validating && (this.getRepeatableGroupId() === null || this.getRepeatableGroupId() === this.reqDef.id) && this.reqObj) {
        this.validateMandatory(validateForm.timeEvent, this.reqObj)
      }
    },
    validateAddForm (validateAddForm) {
      if (validateAddForm.repeatableGroupId && validateAddForm.repeatableGroupId === this.getRepeatableGroupId() && this.reqObj) {
        this.validateMandatory(validateAddForm.timeEventAdd, this.reqObj)
      }
    },
    languageSelected (languageSelected) {
      if (transport.methods.isMultiLanguage(this.reqDef)) {
        this.languageChanged = true
        var self = this
        setTimeout(function () {
          self.languageChanged = false
        }, 550)
      }
    },
    reqObj (reqObj) {
      if (this.isRepeatableGroup()) {
        this.setRepeatableObjectForAdd()
      }
    },
    reqObjForAdd (reqObjForAdd) {
      this.requestObjectForAdd = reqObjForAdd
    },
    reqDef (reqDef) {
      this.initDefinitionObj()
    },
    requestObjectForAdd (requestObjectForAdd) {
      if (this.isRepeatableGroup()) {
        if (this.requestObjectForAdd.id !== this.reqDef.id) {
          this.requestObjectForAdd = this.requestObjectForAddCopy
        }
      }
    },
    parentRepeatableGroupCode (code) {
      this.repeatableGroupCode = code
    }
  }
}
</script>

<style lang="scss">
.definitionObj {
  padding: 0;
  min-height: 80px;
  position: relative;

  &.longText {
    min-height: 147px;
  }

  &.image {
    min-height: 235px;
  }

  &.conditional {
    padding: 0 !important;
    min-height: initial;
  }

  &.form-builder {
    padding: 0;
    min-height: initial;

    .definition-wrapper {
      min-height: 28px;
    }
  }

  .label {
    padding: 7px 0 0;
    font-size: 13px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.1;
    letter-spacing: normal;
    color: #342d38;
    display: inline-block !important;
    transition: background-color 0.4s;

    i {
      font-size: 18px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }

  .bigLabel {
    span {
      font-family: Barlow;
      font-size: 20px;
      vertical-align: text-bottom;
      margin-left: 5px;
      font-weight: 900;
      text-align: left;
      color: #4599a4;
      padding-top: 3px;
    }
  }

  &.pulse {
    label {
      transition: background-color 0.5s;
      background-color: rgba(93,190,203,0.2);
    }
  }

  &.html {
    min-height: 477px;
  }

  &.id,
  &.code {
    display: none !important;
  }

  &.group {
    margin-bottom: 0;
    padding: 0 0 0 0;
    display: flex;

    .no-title > .definition-wrapper > .group-header > .title {
      display: none !important;
    }

    &.w3-half {
      padding: 0 10px !important;
    }
  }

  &.labelHide > label,
  &.labelHide > .definition-wrapper > .title {
    display: none !important;
  }
  &.labelHide > .definition-wrapper {
    padding-top: 31px;
  }

  .toggle_accordion {
    cursor: pointer;
    text-align: left;
    font-size: 14px;
    color: #4599a4;

    i.icon_toggle {
      color: #FFBD42;
      transition: transform .2s;
      -webkit-transform-: .2s;
      margin-left: 5px;
      font-size: 22px;
    }
    i.icon_toggle.rotate180 {
      transform: rotate(180deg);
    }
    > i {
      font-size: 14px;
      color: #FFBD42;

      &:before {
        font-weight: 900;
      }
    }
    > span {
      vertical-align: text-bottom;
      font-family: Capriola;
      font-weight: 100;
    }
  }
}

.definitionObj.home-chart {
  min-height: 600px;
  margin-bottom: 15px;

  > div {
    border-radius: 5px;
    padding: 5px;
  }
}

.definitionObj.home-chart >div>div>div>div {
  margin: 0 auto;
}

.app-container {
  .definitionObj {
    padding: 0 15px 0;
  }
}

#form_definition {
  & > form {
    & > .definitionObj {
      &.group {
        padding: 0 0 0 0;
        margin: 0 0 0 0;
      }
    }
  }
}

.search {
 .definitionObj,
 .definitionObj.group {
    padding: 5px 20px 5px 0px;
    margin-bottom: 0;
    min-height: 100px;
  }

  .group .definitionObj,
  .definitionObj.group .group {
    padding: 0 20px 0 0 !important;
    margin-bottom: 0;
    min-height: 92px !important;
  }

  .group.w3-third,
  .group.w3-quarter,
  .group.w3-half {
    width:100% !important;
  }
}

.definition-wrapper {
  width: 100%;
  min-height: 46px;
  position: relative;

  &.conditional {
    padding: 0;
    min-height: initial;
  }

  .read-only {
    padding-top: 4px;
    display: inline-block;
    font-size: 15px;
    font-family: Barlow;
  }

  .group-elements {
    position: relative;
    float: left;
    width: 100%;

    &.add-repeatable-group-item {
      .groupTasks {
        width: 100%
      }
      .add-hide {
        display: none;
      }
    }
  }
}

.label.error_validate {
  color: #FF3654 !important;
  font-style: italic;
  padding: 6px 0 0;
  position: absolute;
  top: 61px;
  font-size: 12px !important;
  left: 0;
  font-weight: normal !important;
}
.longText {
  .label.error_validate {
    top: 129px;
  }
}
.title {
  .label.error_validate {
    top: 30px;
    left: 10px;
  }
  .toggle_accordion {
    cursor: pointer;
    display: inline-block;

    span:first-of-type span.add {
      text-transform: capitalize;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.hide {
  display:none !important;
}

.tinymcetmd {
  width: 100%;
}

.error_validate {
  input,
  textarea,
  .multiselect__tags,
  .tinymcetmd {
    border: 1px solid #FF3654 !important;
  }
}
.ok_validate {
  input,
  textarea,
  .multiselect__tags,
  .tinymcetmd {
    border: 1px solid #13BD38 !important;
  }
}

input:focus,
textarea:focus {
  border: 1px solid #3485FE !important;
  box-shadow: 0px 0px 4px rgba(52, 133, 254, 0.41);
}

.title .sherpa-icon {
  cursor: pointer;
  margin-left: 5px;
  color: #4599a4;
  font-size: 16px;
  margin-bottom: 7px;
}
.title .sherpa-icon:before {
  transition: all 0.2s ease-in;
}
.title .sherpa-icon.open:before {
  -ms-transform: rotateZ(90deg);
  -webkit-transform: rotateZ(90deg);
  transform: rotateZ(90deg);
}

.taskGroup {
  button {
    margin: 20px 5px 5px;
    // treure el css white-space per què es comporti com un botó normal
    white-space: initial;
  }
}

.groupTasks {
  padding: 8px 0 0 15px;
  float: left;
}

.icon-facebook {
  color: #3B5998;
}
.icon-twitter {
  color: #55ACEE;
}
.icon-instagram {
  color: #316699;
}
.icon-linkedin {
  color: #007BB5;
}
.icon-pinterest {
  color: #CA2028;
}
.icon-googleplus {
  color: #E02F2F;
}
.multiselect__content-wrapper i,
.multiselect__tags i{
  vertical-align: middle;
  font-size: 17px;
  margin-right: 6px;
}

.pointer {
  cursor: pointer;
}
.label {
  i.fa-angle-down {
    font-size: 2em !important;
    margin-left: 5px;
    transition: all .2s;
    color: #FFBD42;

    &.open {
      transform: rotateZ(180deg);
    }
  }
}

.definitionObj-short {
  min-height: 92px !important;
}
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/definitionObj.vue